import React, { useEffect,useRef }  from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as types from "../../constants/actionTypes";
import EstimateDetails from '../estimates/estimateDetails';
import MyEstimates from '../estimates/myEstimates';
import PaymentOptions from '../estimates/paymentOptions';
import ErrorMessage from "../estimates/ErrorMessage";
import { logUI } from "../../api/andyliticsApi";
//import useAccessList from "./hooks/useAccessList";
import useGaurdEstimate from "./hooks/useGaurdEstimate";
import { BottomScrollListener } from 'react-bottom-scroll-listener';
import { getQueryStringValue } from "../../helpers/Tools";
//const components = { estimateDetails: EstimateDetails, myEstimates: MyEstimates, paymentOptions: PaymentOptions };

const EstimatesWrapper = props => {
    const start = new Date();
    const { currentUser, activeProfilePatient, history, clear, getAppointments, getBenefitDetails, getPDF, epic } = props;
    const patient = activeProfilePatient;//props.epic;
    const { page,id } = props.match.params;

    
    const prevUserRef = useRef();
    useEffect(() => {
        prevUserRef.current = patient;
    });
    const prevUser = prevUserRef.current;
    useGaurdEstimate(page, prevUser, patient, history,props);
/* eslint-disable react-hooks/exhaustive-deps */

    useEffect(() => {
        if (page.toLowerCase() === 'myestimates' || page.toLowerCase() === 'list') {
            getAppointments(patient);
        }
        logUI(`MBHWeb.UI.Estimates.estimatesWrapper.${page}`, new Date(), `${page}`, window.store.getState().pricing, page, 'page viewed');
    }, [props.match.params.page, patient.EID]);

    useEffect(() => {
        const csnId = id ? id : getQueryStringValue(props.location.search, 'CSN');
        if (csnId !== '') {
            clear();
            if (page.toLowerCase() === 'estimatedetails' || page.toLowerCase() === 'details') {
                getBenefitDetails(patient,csnId);
                getPDF(patient,csnId);
            }
            logUI(`MBHWeb.UI.Estimates.estimatesWrapper.${page}`, new Date(), `${page}/${csnId}`, window.store.getState().pricing, page, 'page viewed');
        } else {
            logUI(`MBHWeb.UI.Estimates.estimatesWrapper.${page}`, new Date(), `${page}/${csnId}`, window.store.getState().pricing, page, 'no CSN for page');
        }
    }, [props.match.params.id]);

/* eslint-enable react-hooks/exhaustive-deps */

    try {
        switch (page) {
            case 'estimateDetails':
                return <BottomScrollListener onBottom={() => { handleContainerOnBottom(props,start); }}>
                    <EstimateDetails
                    error={{}}
                    csnId={''}
                    benefitDetails={props.benefitDetails}
                    currentUser={currentUser}
                    patient={patient}
                    pdf={ props.pdf}
                    />
                </BottomScrollListener>
            case 'list':
                return <MyEstimates
                    error={{}}
                    loaded={props.appointmentsLoaded}
                    appointments={props.appointments}
                    currentUser={currentUser}
                    patient={patient}
                />
            case 'myEstimates':
                return <MyEstimates
                    error={{}}
                    loaded={props.appointmentsLoaded}
                    appointments={props.appointments}
                    currentUser={currentUser}
                    patient={patient}
                        />
            case 'paymentOptions':
                return <PaymentOptions />
            default:
                return <div>default</div>;
                //return <Comp
                            
                //            un={window.store.getState().domain.cu.mi}
                //            displayName={window.store.getState().domain.cu.dn}
                //            enablePricingTransparency={window.store.getState().session.serverData.enablePricingTransparency}
                //            appointments={window.store.getState().pricing.appointments}
                //            selectedAppointment={window.store.getState().pricing.selectedAppointment}
                //            />;

        }
        
    } catch (e) {
        console.error(`estimatesWrapper exception`, e);
        logUI("Estimates.estimateWrapper", new Date(), `/`, props, 'ERROR', e.message); 
        return <ErrorMessage />;
    }
}
const handleContainerOnBottom = (props,start) => {
    const { id } = props.match.params;
    logUI("MBHWeb.UI.Estimates.estimateDetails", start, `estimateDetails/${id}`, props, 'Scrolled To Bottom',id);
}
const mapStateToProps = (state) => {
    //console.info(`estimatesWrapper currentUser, activeProfilePatient`, state.memberships.primaryUser, state.memberships.activeProfile.patient);
    return {
        appointmentsLoaded: state.pricing.appointmentsLoaded,
        appointments: state.pricing.appointments,
        currentUser: state.memberships.primaryUser,
        activeProfilePatient: state.memberships.activeProfile.patient,
        benefitDetails: state.pricing.benefitDetails,
        //accessList: state.pricing.accessList,
        epic: state.memberships.membershipData.epic,
        pdf: state.pricing.pdf,
        hasMyChart: state.domain.hm
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        clear: () => { dispatch({ type: types.PRICING_USERSQUOTE_QUOTE_CLEAR})},
        getAppointments: (currentUser) => { dispatch({ type: types.PRICING_USERSQUOTE_APPOINTMENTS, data: { currentUser:currentUser } }); },
        getBenefitDetails: (currentUser, csnId) => { dispatch({ type: types.PRICING_USERSQUOTE_BENEFITDETAILS, data: { csnIdOfAppointment: csnId,  currentUser: currentUser  } }); },
        getPDF: (currentUser, csnId) => {dispatch({ type: types.PRICING_USERSQUOTE_ESTIMATE_PDF, data: { token: window.store.getState().domain.t, currentUser: currentUser , csnId: csnId } }); },
    }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(EstimatesWrapper));

